"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.824 3.5H20.29c1.528 0 2.767 1.296 2.767 2.896v11.209c0 1.599-1.239 2.895-2.767 2.895H3.824c-1.528 0-2.766-1.296-2.766-2.895V6.395c0-1.599 1.238-2.895 2.766-2.895Zm0 1.93c-.51 0-.922.432-.922.966v11.209c0 .532.413.965.922.965H20.29c.51 0 .922-.433.922-.965V6.395c0-.533-.412-.965-.922-.965H3.824Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.926 14.315c0-.967.788-1.75 1.76-1.75h4.487c.973 0 1.76.783 1.76 1.75v3.113h-1.508v-3.114a.25.25 0 0 0-.252-.25H5.686a.25.25 0 0 0-.251.25v3.114h-1.51v-3.114Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M9.942 9.463c0 1.105-.901 2-2.012 2a2.006 2.006 0 0 1-2.012-2c0-1.105.9-2 2.012-2 1.11 0 2.012.895 2.012 2Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.918 8.221c0-.419.34-.758.758-.758h4.484a.758.758 0 0 1 0 1.517h-4.484a.758.758 0 0 1-.758-.759ZM13.918 11.687c0-.419.34-.758.758-.758h4.484a.758.758 0 0 1 0 1.516h-4.484a.758.758 0 0 1-.758-.758Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};